export default __webpack_public_path__ + "static/media/data-upload.46720b34.svg";